var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8337 6.6665H3.50033C3.04033 6.6665 2.66699 7.03984 2.66699 7.49984V9.1665C2.66699 9.6265 3.04033 9.99984 3.50033 9.99984H16.8337C17.2937 9.99984 17.667 9.6265 17.667 9.1665V7.49984C17.667 7.03984 17.2937 6.6665 16.8337 6.6665Z",
    stroke: "#0E0B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1672 17.4998V6.6665",
    stroke: "#0E0B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.247 5.51025C12.3487 6.44525 10.9345 6.66692 10.2495 6.66692",
    stroke: "#0E0B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2494 6.6666C10.2494 6.6666 9.83778 4.06993 10.8503 3.0166",
    stroke: "#0E0B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2469 5.51007C13.9086 4.82174 13.9086 3.70507 13.2469 3.01674C12.5852 2.3284 11.5127 2.3284 10.8511 3.01674",
    stroke: "#0E0B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08691 5.51025C7.98525 6.44525 9.39941 6.66692 10.0844 6.66692",
    stroke: "#0E0B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0844 6.6666C10.0844 6.6666 10.496 4.06993 9.48354 3.0166",
    stroke: "#0E0B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08707 5.51007C6.4254 4.82174 6.4254 3.70507 7.08707 3.01674C7.74874 2.3284 8.82124 2.3284 9.4829 3.01674",
    stroke: "#0E0B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 10V16.6667C16.0002 17.1267 15.6268 17.5 15.1668 17.5H5.16683C4.70683 17.5 4.3335 17.1267 4.3335 16.6667V10",
    stroke: "#0E0B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/Gift.ecd3ec9befa6a51b07fe4ce27f2a1813.svg";
export { ForwardRef as ReactComponent };